<template lang="pug">
#waiver-form.modal-card
  header.modal-card-head
    p.modal-card-title {{ waiver.name }}
  section.modal-card-body
    .content
      p(v-html="compiledBody")
  footer.modal-card-foot
    a.button.is-light(@click="$parent.close()") Close
</template>

<script>
import { mapGetters } from 'vuex';
import marked from 'marked';
import * as getters from '@/store/types/getters';

export default {
  name: 'waiver-form',
  computed: {
    ...mapGetters({
      waiver: getters.GET_WAIVER,
    }),
    compiledBody() {
      if (this.waiver.id === undefined || !this.waiver.body) return null;
      return marked(this.waiver.body);
    },
  },
};
</script>

<style lang="scss">
</style>
